import React, { useEffect, useState } from "react";
import {
  Box,
  Avatar,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Card,
  CardContent,
  Grid,
  Container,
  Button,
  TextField,
  Modal,
  Alert,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import {
  Favorite,
  ArrowBack,
  ChevronRight,
  Star as StarIcon,
  StarOutline as StarOutlineIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
// Import your icons
import Appointment_Icon from "../../assets/img/icons/appoinment_icon.png";
import Fav_Icon from "../../assets/img/icons/my_fav_icon.png";
import Update_Profile_Icon from "../../assets/img/icons/update_profile_icon.png";
import Delete_Icon from "../../assets/img/icons/delete_icon.png";
import Sign_Out_Icon from "../../assets/img/icons/sign_out_icon.png";
import fav_img from "../../assets/img/fav_img.png";
import locationIcon from "../../assets/locationIconHome.png";
import Camera_Icon from "../../assets/img/icons/camera_icon.png";
import Gallery_Icon from "../../assets/img/icons/gallery_icon.png";
import { swalAlertPopProps } from "../../utils/commonUtils";
import { routePath } from "../../constants/routePath";
import CloseIcon from "@mui/icons-material/Close";
import { APPOINMENT, UPDATEUSERPROFILE } from "../../utils/api";
import SalonImage from "../../assets/salonImage2.png";
import { GETALLCUSTOMERCREATEDAPPOINMENT } from "../../utils/api";
import axios from "axios";
import { setProfileTab, setUserDetail } from "../../app/store/reducer";
import dayjs from "dayjs";
const FavoritePage = () => {
  const reduxActiveTab = useSelector((state) => state.reducer.activeTab);
  const [activeTab, setActiveTab] = useState("appointments");
  const [appointments, setAppointments] = useState([]);
  const [isLoadingAppointments, setIsLoadingAppointments] = useState(false);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const favorites = useSelector((state) => state.reducer.favProduct); // Replace with your actual slice name
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //console.log(favorites, "favoritesfavorites");
  // Sample data - replace with your actual data
  const favoriteItems = [
    {
      id: 1,
      title: "Urban Salon (B Id)",
      location: "Uttam",
      service: "Service at - Home & Salon",
      city: "Pune",
      averageRating: 4.5,
      totalRating: 120,
      image: fav_img,
    },
  ];

  const appointmentData = [
    {
      month: "JAN",
      day: "15",
      year: "2023",
      time: "10:30 AM",
      name: "Akshay Dhumal",
      salon: "Elegant Salon",
      services: "Haircut, Beard Trim",
      mobile: "+91 9876543210",
      status: "Assigned",
    },
  ];

  const fetchAppointments = async () => {
    try {
      setIsLoadingAppointments(true);
      const token = sessionStorage.getItem("smbToken");
      if (!token) throw new Error("No authentication token found");

      const payload = {
        billerId: 0,
        page: 1,
        pageSize: 1000,
        filter: "string",
        search: "string",
        showAllAppoitmentsAccrossBiller: true,
      };

      const response = await axios.post(
        `https://elegantprime.in/webapp/${GETALLCUSTOMERCREATEDAPPOINMENT}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      setAppointments(response.data?.data?.list ?? []);
    } catch (error) {
      console.error("Failed to fetch appointments:", error);
      setAppointments([]);
    } finally {
      setIsLoadingAppointments(false);
    }
  };
  useEffect(() => {
    setActiveTab(reduxActiveTab);
  }, [reduxActiveTab]);

  useEffect(() => {
    if (activeTab === "appointments") {
      fetchAppointments();
    }
  }, [activeTab]);
  const handleSignOut = async () => {
    try {
      await sessionStorage.clear();
      await localStorage.clear();
      dispatch(setUserDetail({}));
      dispatch({ type: "CLEAR_USER_DATA" });
      Swal.fire({
        title: "Signed Out",
        text: "You have been successfully signed out",
        icon: "success",
        ...swalAlertPopProps,
      });
      navigate(routePath.LANDINGPAGE);
    } catch (error) {
      console.error("Sign out error:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to sign out",
        icon: "error",
        ...swalAlertPopProps,
      });
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    dispatch(setProfileTab(tabName));
  };
  const [open, setOpen] = useState(true);

  const [isLoading, setIsLoading] = useState(true);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [profileData, setProfileData] = useState([
    { label: "Name", value: "", field: "name" },
    { label: "Address", value: "", field: "address" },
    { label: "Mobile", value: "", field: "mobile" },
  ]);

  // 2. Modify your fetchUserProfile function to properly set the data
  const fetchUserProfile = async () => {
    try {
      setIsLoading(true);
      const token = sessionStorage.getItem("smbToken");
      if (!token) throw new Error("No authentication token found");

      const response = await axios.get(
        "https://elegantprime.in/webapp/user/api/v1/UserMaster/GetUserProfile",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Update form fields with API data from response.data.data
      setProfileData((prev) =>
        prev.map((field) => ({
          ...field,
          value: response.data.data[field.field] || "", // Access data.data
        })),
      );
      //console.log(profileData, "profileData");
    } catch (error) {
      console.error("Failed to fetch profile:", error);
      setNotification({
        open: true,
        message: error.response?.data?.message || "Failed to load profile",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Load data when component mounts
  useEffect(() => {
    fetchUserProfile();
  }, []);

  // Handle input changes
  const handleInputChange = (index, value) => {
    setProfileData((prev) => {
      const newData = [...prev];
      newData[index] = { ...newData[index], value };
      return newData;
    });
  };

  // Handle form submission
  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const token = sessionStorage.getItem("smbToken");
      if (!token) throw new Error("No authentication token found");

      // Convert profileData to the required API format
      const requestBody = profileData.reduce((acc, field) => {
        acc[field.field] = field.value;
        return acc;
      }, {});

      await axios.post(
        "https://elegantprime.in/webapp/user/api/v1/UserMaster/UpdateUserProfile",
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      setNotification({
        open: true,
        message: "Profile updated successfully!",
        severity: "success",
      });

      // Refresh data after update
      await fetchUserProfile();
    } catch (error) {
      console.error("Failed to update profile:", error);
      setNotification({
        open: true,
        message: error.response?.data?.message || "Failed to update profile",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  if (isLoading && profileData.every((field) => field.value === "")) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (isLoading) {
    return <CircularProgress />;
  }

  // const favProductString = sessionStorage.getItem("favProduct");

  // if (favProductString) {
  //   try {
  //     const favProduct = JSON.parse(favProductString);
  //     //console.log(favProduct, "AkshayfavProduct");
  //   } catch (e) {
  //     console.error("Failed to parse favProduct:", e);
  //   }
  // }

  const renderContent = () => {
    switch (activeTab) {
      case "appointments":
        return (
          <Box>
            <Typography sx={{
              display: 'flex',
              p:{xs:2, sm:0}
            }} variant="h5" fontWeight={600} mb={{sm:3, xs:0}}>
              My Appointments
            </Typography>

            {isLoadingAppointments ? (
              <CircularProgress />
            ) : appointments.length === 0 ? (
              <Typography>No appointments found.</Typography>
            ) : (
              <Box
                display="flex"
                sx={{
                  maxHeight: "60vh",
                  overflowY: "auto",
                  px:{xs:1, sm:0}
                }}
                gap={{ sm: 5, md: 2, lg: 2, xl: 3 }}
                flexWrap="wrap"
              >
                {appointments.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: { sm: 350, md: 300, lg: 350 },
                      display: "flex",
                      borderRadius: 2,
                      overflow: "hidden",
                      boxShadow: 3,
                      border: "1px solid #ddd",
                      backgroundColor: "#fff",
                      mb: { xs:2, sm: 0, md: 0 },
                    }}
                  >
                    <Box
                      sx={{
                        width: 90,
                        backgroundColor: "#f9f9f9",
                        borderRight: "1px solid #ddd",
                        textAlign: "center",
                        py: 2,
                        // px: 3
                      }}
                    >
                      <Typography fontSize={14} color="textSecondary">
                        {dayjs(item.date).format("MMM")}
                      </Typography>
                      <Typography fontSize={24} fontWeight="bold">
                        {dayjs(item.date).format("DD")}
                      </Typography>
                      <Typography fontSize={13} color="textSecondary">
                        {dayjs(item.date).format("YYYY")}
                      </Typography>

                      <Divider sx={{ my: 1, mx: "auto", width: "60%" }} />

                      <Typography fontSize={12} fontWeight="600">
                        Time
                      </Typography>
                      <Typography fontSize={13}>
                        {dayjs(item.date)
                          .hour(item.hour)
                          .minute(item.minute)
                          .format("hh:mm A")}
                      </Typography>
                    </Box>

                    <Box sx={{ p: 2, flex: 1 }}>
                      <Typography fontSize={14}>
                        For <b>{item.customerName ?? "N/A"}</b>
                      </Typography>
                      <Typography fontSize={14}>
                        From <b>{item.enterpriseName ?? "N/A"}</b>
                      </Typography>

                      <Divider sx={{ my: 1 }} />

                      <Grid container spacing={1}>
                        <Grid item xs={7}>
                          <Typography fontSize={13} fontWeight="600">
                            Services
                          </Typography>
                          <Typography fontSize={13} color="text.secondary">
                            {Array.isArray(item.services)
                              ? item.services.map((s) => s.service).join(", ")
                              : (item.services ?? "-")}
                          </Typography>
                        </Grid>

                        <Grid item xs={5}>
                          <Typography fontSize={13} fontWeight="600">
                            Mobile
                          </Typography>
                          <Typography fontSize={13} color="text.secondary">
                            {item.mobileNumber ?? "-"}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Box
                        mt={1}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        {/* Appointment Id (label + value in column) */}
                        <Box display="flex" flexDirection="column">
                          <Typography fontSize={13} fontWeight="600">
                            Appointment Id
                          </Typography>
                          <Typography fontSize={13} color="text.secondary">
                            {item.appointmentId ?? "-"}
                          </Typography>
                        </Box>

                        {/* Status button */}
                        {/* {item.status === "Assigned" ? (
                          <Button
                            size="small"
                            variant="contained"
                            sx={{
                              backgroundColor: "#3f2aa1",
                              borderRadius: "12px",
                              textTransform: "none",
                              fontSize: 12,
                              px: 2,
                              py: 0,
                              minHeight: "28px",
                            }}
                          >
                            {item.status}
                          </Button>
                        ) : (
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{
                              borderRadius: "12px",
                              textTransform: "none",
                              fontSize: 12,
                              px: 2,
                              py: 0,
                              minHeight: "28px",
                              color: "#3f2aa1",
                              borderColor: "#3f2aa1",
                            }}
                          >
                            {item.status}
                          </Button>
                        )} */}
                        <Button
                          size="small"
                          variant="contained"
                          sx={{
                            backgroundColor: "#3f2aa1",
                            borderRadius: "12px",
                            textTransform: "none",
                            fontSize: 12,
                            px: 2,
                            py: 0,
                            minHeight: "28px",
                            "&:hover": {
                              backgroundColor: "#33208a", // darker shade on hover
                            },
                          }}
                        >
                          {item.status}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        );

      case "favorites":
        return (
          <>
            <Typography variant="h5" fontWeight={600} mb={3}>
              My Favourite
            </Typography>
            <Grid container spacing={2}>
              {favorites.map((item) => {
                const stars = Array.from({ length: 5 }, (_, i) =>
                  i < item.averageRating ? (
                    <StarIcon
                      key={i}
                      sx={{ color: "#ff5e00", fontSize: "18px" }}
                    />
                  ) : (
                    <StarOutlineIcon
                      key={i}
                      sx={{ color: "#ff5e00", fontSize: "18px" }}
                    />
                  ),
                );

                return (
                  <Grid item xs={12} sm={6} key={item.id}>
                    <Card sx={{ display: "flex", borderRadius: 2 }}>
                      <Box
                        sx={{
                          width: 160,
                          height: 140,
                          flexShrink: 0,
                          pl: 1.5,
                        }}
                      >
                        <img
                          src={item.image ?? SalonImage}
                          alt={"image"}
                          style={{
                            width: "100%",
                            height: "100%",
                            // objectFit: "cover",
                          }}
                        />
                      </Box>

                      <Box sx={{ flex: 1, position: "relative" }}>
                        <IconButton
                          sx={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            color: "red",
                          }}
                        >
                          <Favorite />
                        </IconButton>
                        <CardContent>
                          <Typography fontWeight="bold">
                            {item?.enterpriseName ?? "N/A"} (B ID{" "}
                            {item?.billerId ?? "N/A"})
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {item?.area ?? "N/A"}
                          </Typography>
                          <Typography variant="body2">
                            {item?.businessCategory ?? "N/A"}
                          </Typography>
                          <Typography
                            fontSize="13px"
                            display="flex"
                            alignItems="center"
                          >
                            <img
                              src={locationIcon}
                              alt="Location"
                              style={{ width: "15px", marginRight: "4px" }}
                            />
                            {item?.area ?? "N/A"}
                          </Typography>
                          <Box display="flex" alignItems="center" mt={0.5}>
                            {stars}
                            <Typography
                              component="span"
                              fontSize="13px"
                              ml={1}
                              color="text.secondary"
                            >
                              {item.averageRating} ({item.totalRating}{" "}
                              {item.totalRating === 1 ? "Review" : "Reviews"})
                            </Typography>
                          </Box>
                        </CardContent>
                      </Box>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </>
        );

      case "update_profile":
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        return (
          <Box>
            <Typography
              variant="h6"
              sx={{ color: "#01008B", fontWeight: "bold", mb: 3 }}
            >
              Update Profile
            </Typography>
            <Grid container spacing={4} alignItems="center">
              {/* Profile Image */}
              <Grid item xs={12} md={4} textAlign="center">
                <Box position="relative" display="inline-block">
                  <Avatar
                    onClick={handleOpen}
                    sx={{
                      width: 130,
                      height: 130,
                      mx: "auto",
                      cursor: "pointer",
                    }}
                    src=""
                    alt="Profile"
                  />
                  <Box
                    onClick={handleOpen}
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      right: "calc(55% - 80px)",
                      borderRadius: "50%",
                      padding: "4px",
                      cursor: "pointer",
                    }}
                  >
                    <CameraAltIcon sx={{ color: "#01008B", fontSize: 30 }} />
                  </Box>
                </Box>
              </Grid>

              {/* Form Fields */}
              <Grid item xs={12} md={8}>
                <Box p={{ sm: 3, xs: 1 }}>
                  <Grid container spacing={4}>
                    {/* Form Fields */}
                    <Grid item xs={12} md={8}>
                      <Grid container spacing={2}>
                        {profileData.map((field, index) => (
                          <Grid item xs={12} key={index}>
                            <TextField
                              label={field.label}
                              value={field.value}
                              onChange={(e) =>
                                handleInputChange(index, e.target.value)
                              }
                              fullWidth
                              variant="outlined"
                              InputProps={{
                                readOnly: field.field === "mobile", // Make mobile field read-only
                                sx: {
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "14px",
                                  },

                                  borderRadius: "4px",
                                  borderColor: "#01008B",
                                },
                              }}
                              InputLabelProps={{
                                sx: {
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "14px",
                                  },
                                  color: "#000",
                                  fontWeight: 500,
                                },
                              }}
                              sx={{
                                "& fieldset": {
                                  borderColor: "#01008B",
                                },
                                "&:hover fieldset": {
                                  borderColor:
                                    field.field === "mobile"
                                      ? "rgba(0, 0, 0, 0.23)"
                                      : "#01008B",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor:
                                    field.field === "mobile"
                                      ? "rgba(0, 0, 0, 0.23)"
                                      : "#01008B",
                                },
                                backgroundColor:
                                  field.field === "mobile"
                                    ? "#f5f5f5"
                                    : "inherit", // Gray background for mobile
                              }}
                            />
                          </Grid>
                        ))}

                        <Grid item xs={12} textAlign="center" mt={2}>
                          <Button
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={isLoading}
                            sx={{
                              backgroundColor: "#01008B",
                              fontSize: { xs: "12px", sm: "13px", md: "14px" },
                              textTransform: "none",
                              px: 4,
                              "&:disabled": {
                                backgroundColor: "#cccccc",
                              },
                            }}
                          >
                            {isLoading ? "Updating..." : "Update Profile"}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Notification Snackbar */}
                  <Snackbar
                    open={notification.open}
                    autoHideDuration={6000}
                    onClose={handleCloseNotification}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  >
                    <Alert
                      onClose={handleCloseNotification}
                      severity={notification.severity}
                      sx={{ width: "100%" }}
                    >
                      {notification.message}
                    </Alert>
                  </Snackbar>
                </Box>
              </Grid>
            </Grid>

            {/* Popup Modal */}
            <Modal open={open} onClose={handleClose}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 300,
                  bgcolor: "background.paper",
                  borderRadius: 2,
                  boxShadow: 24,
                  p: 4,
                  textAlign: "center",
                }}
              >
                {/* Close Button */}
                <IconButton
                  onClick={handleClose}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                  }}
                >
                  <CloseIcon sx={{ color: "#01008B" }} />
                </IconButton>

                {/* Take Photo Option */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mb: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    // Implement take photo functionality
                    handleClose();
                  }}
                >
                  <img
                    src={Camera_Icon}
                    alt="Take Photo"
                    width={30}
                    height={30}
                  />
                  <Typography color="primary" fontWeight={600}>
                    Take Photo
                  </Typography>
                </Box>

                {/* Choose from Gallery Option */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    // Implement choose from gallery functionality
                    handleClose();
                  }}
                >
                  <img
                    src={Gallery_Icon}
                    alt="Choose from Gallery"
                    width={30}
                    height={30}
                  />
                  <Typography color="primary" fontWeight={600}>
                    Choose from Gallery
                  </Typography>
                </Box>
              </Box>
            </Modal>

            {/* Notification Snackbar */}
            <Snackbar
              open={notification.open}
              autoHideDuration={6000}
              onClose={handleCloseNotification}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert
                onClose={handleCloseNotification}
                severity={notification.severity}
                sx={{ width: "100%" }}
              >
                {notification.message}
              </Alert>
            </Snackbar>
          </Box>
        );
    }
  };

  return (
    <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh", pb: 2 }}>
      {/* Gradient Background */}
      <Box
        sx={{
          height: "25vh",
          background:
            "linear-gradient(93.11deg, #7A79FF 13.11%, #01008B 84.65%)",
          position: "relative",
        }}
      >
        <IconButton
          sx={{
            position: "absolute",
            top: 20,
            left: 20,
            color: "white",
            zIndex: 10,
          }}
          onClick={() => window.history.back()}
        >
          <ArrowBack />
        </IconButton>
      </Box>

      {/* Content Section */}
      <Container sx={{ mt: -20, zIndex: 5, position: "relative" }}>
        <Grid container spacing={3}>
          {/* Left Profile Section - 4 columns */}
          <Grid item xs={12} md={3}>
            <Box
              sx={{
                height: "71vh",
                // overflowY: "auto",
              }}
              bgcolor="#fff"
              boxShadow={2}
              p={2}
            >
              <Typography
                variant="h6"
                mb={1}
                fontWeight={600}
                color={"#01008B"}
                textAlign={"center"}
              >
                Profile
              </Typography>
              <Box display="flex" flexDirection="column" alignItems="center">
                <Avatar sx={{ width: 80, height: 80 }} />
                <Typography
                  variant="h6"
                  mt={1}
                  fontWeight={600}
                  color={"#01008B"}
                >
                  {profileData.find((item) => item.field === "name")?.value ||
                    "N/A"}
                </Typography>
              </Box>

              <Box mt={2}>
                <Typography variant="body2" fontWeight={600} color={"#01008B"}>
                  Address :
                </Typography>
                <Typography variant="body2">
                  {profileData.find((item) => item.field === "address")
                    ?.value || "N/A"}
                </Typography>
                <Divider sx={{ my: 1 }} />

                <Typography
                  variant="body2"
                  mt={1}
                  fontWeight={600}
                  color={"#01008B"}
                >
                  Mobile No :
                </Typography>
                <Typography variant="body2">
                  {profileData.find((item) => item.field === "mobile")?.value ||
                    "N/A"}
                </Typography>
              </Box>

              <Divider sx={{ my: 1 }} />

              <List dense>
                {[
                  {
                    icon: Appointment_Icon,
                    label: "My Appointment",
                    text_color: "#01008B",
                    tab: "appointments",
                  },
                  {
                    icon: Fav_Icon,
                    label: "My Favourite",
                    text_color: "#01008B",
                    tab: "favorites",
                  },
                  {
                    icon: Update_Profile_Icon,
                    label: "Update Profile",
                    text_color: "#01008B",
                    tab: "update_profile",
                  },
                  {
                    icon: Delete_Icon,
                    label: "Request For Delete The Account",
                    text_color: "#01008B",
                  },
                  {
                    icon: Sign_Out_Icon,
                    label: "Sign Out",
                    text_color: "red",
                    onClick: handleSignOut,
                  },
                ].map((item, idx) => (
                  <ListItem
                    key={idx}
                    button
                    onClick={item.onClick || (() => handleTabClick(item.tab))}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      px: 0,
                      backgroundColor:
                        activeTab === item.tab ? "#f0f0f0" : "inherit",
                      "&:hover": {
                        backgroundColor:
                          item.text_color === "red" ? "#ffebee" : "#f5f5f5",
                      },
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={item.label}
                        style={{ width: 24, height: 24 }}
                      />
                      <ListItemText
                        primary={item.label}
                        sx={{ fontWeight: 600, color: item.text_color }}
                      />
                    </span>
                    <ChevronRight sx={{ color: "#01008B" }} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>

          {/* Right Content Section - 8 columns */}
          <Grid item xs={12} md={9}>
            <Box bgcolor={"#fff"} p={{ sm: 1, md: 3, lg: 4 }} boxShadow={2}>
              {renderContent()}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FavoritePage;
